import React from "react";
import format from "date-fns/format";
// Material imports
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
var useStyles = makeStyles(function (theme) {
  return {
    caption: {
      color: theme.palette.contrast.text
    }
  };
});

var TimePosted = function TimePosted(_ref) {
  var time = _ref.time;
  var classes = useStyles();
  var formattedTime = format(time, "H:mm");
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    classes: {
      caption: classes.caption
    }
  }, formattedTime);
};

export default TimePosted;